import React, { useEffect, FC } from 'react';
import { ProductSelectorProps } from './types/productSelector.types';
import { ProductSelectorModel } from './models/productSelector.model';
import { documentService } from '../../utils/window.utils';

const ProductSelector: FC<ProductSelectorProps> = (props) => {
  const model = new ProductSelectorModel(props);

  useEffect(() => {
    const addScript = documentService().createElement('script');
    addScript.setAttribute('src', model?.src);
    if (documentService()?.body) {
      documentService()?.body.appendChild(addScript);
    }
  }, []); /* eslint-disable-line */

  return (
    <div id="xc_application">
      <div id="xc_application_pane"></div>
      <div id="xc_loader"></div>
    </div>
  );
};

export default ProductSelector;
